<template>
	<div id="app">
		<div class="top-tab">
			<div v-if="$route.name!='Login'" v-show="notShow" class="right-userinfo">
				<userinfo></userinfo>
			</div>
		</div>
		<div class="content">
			<router-view />
		</div>
		
	</div>
</template>

<script>
	import userinfo from './components/userinfo.vue'
	export default {
		name: 'app',
		components: {userinfo},
		data() {
			return {
				notShow:false,
			}
		},
		mounted() {
			setTimeout(()=>{
				this.notShow = true;
			},1000)
		},
		watch: {
			
		},
		methods: {
			
		},
	}
</script>

<style lang="scss">
	#app {
		font-family: 微软雅黑, Helvetica, Neue, Helvetica, STHeiTi, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		// padding: 16px;
		width: 100%;
		height: 100%;
		background-color: #F3F5F6;
		.top-tab{
			width: 100%;
			height: 60px;
			background: url(./assets/imgs/logo.png) 30px center no-repeat;
			background-color: #fff;
			box-shadow: 0px 2px 7px 0px rgba(208,208,208,0.4);
			position: relative;
			.right-userinfo{
				position: absolute;
				right: 30px;
				top: 20px;
			}
		}
		.content{
			width: 100%;
			height: calc(100% - 60px);
		}
		.question-list{
			.el-table{
				border: 1px solid #ccc;
				.el-table__header-wrapper{
					thead{
						tr{
							th{
								background-color: #F2F2F2 !important;
								.cell{
									color: #333 !important;
								}
							}
						}
					}
				}
				
			}
		}
		
	}
</style>
